import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Lock } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Logo } from "@/components/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password, remember_me: rememberMe });
      localStorage.setItem("admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4 py-16" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm rounded-3xl border border-white/10 bg-[#141419] p-8" data-testid="admin-login-form">
        <div className="mb-8 flex flex-col items-center">
          <Logo size={52} />
          <h1 className="font-heading mt-4 text-xl font-bold text-white">Admin Access</h1>
          <p className="mt-1 text-xs text-zinc-500">Beats, orders & bookings control room</p>
        </div>
        <input
          type="email" required placeholder="Admin email" value={email}
          onChange={(e) => setEmail(e.target.value)}
          data-testid="admin-email-input"
          className="mb-3 w-full rounded-xl border border-white/10 bg-[#0B0B0E] px-4 py-3 text-sm text-white outline-none focus:border-emerald-300/60"
        />
        <input
          type="password" required placeholder="Password" value={password}
          onChange={(e) => setPassword(e.target.value)}
          data-testid="admin-password-input"
          className="mb-3 w-full rounded-xl border border-white/10 bg-[#0B0B0E] px-4 py-3 text-sm text-white outline-none focus:border-emerald-300/60"
        />
        <label className="mb-4 flex cursor-pointer items-center gap-2 text-xs text-zinc-400 select-none" data-testid="admin-remember-wrap">
          <input
            type="checkbox"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            data-testid="admin-remember-checkbox"
            className="h-4 w-4 cursor-pointer rounded border-white/20 bg-[#0B0B0E] accent-emerald-300"
          />
          Remember me on this device <span className="text-zinc-600">· 30 days</span>
        </label>
        {error && <p className="mb-4 rounded-lg border border-red-500/30 bg-red-500/10 px-3 py-2 text-xs text-red-400" data-testid="admin-login-error">{error}</p>}
        <button
          type="submit" disabled={loading} data-testid="admin-login-submit"
          className="flex w-full items-center justify-center gap-2 rounded-full bg-emerald-300 py-3.5 text-sm font-bold uppercase tracking-wider text-black transition-colors hover:bg-emerald-200 disabled:opacity-50"
        >
          {loading ? <Loader2 size={15} className="animate-spin" /> : <Lock size={14} />}
          Sign In
        </button>
      </form>
    </div>
  );
}
